import React from 'react'
import mapContent from './contentMapper'

function ComponentContainer(props) {
  return <>{props.content && mapContent(props.content)}</>
}

export default ComponentContainer
